import { create } from "zustand";

export const useRecibosPagosStore = create((set) => ({
  recibos: null,
  recibosFilter: null,
  montoTotal: null,

  setRecibos: (recibos) => {
    set({
      recibos: recibos,
      recibosFilter: recibos,
    });
  },

  setRecibosFilter: (recibos) => {
    set({ recibosFilter: recibos });
  },

  setMontoTotal: (monto) => {
    set({ montoTotal: monto });
  },
}));
